// !--- Trryst Confidential. Please do not share or distribute without approval from Trryst (CSuite Ltd.)
import React from "react";

const MeetingTopbar = ({ ...rest }) => {
  return <div></div>;
};

export default MeetingTopbar;
